import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import { FUTURE, TIMELINE_PATHNAME } from 'timeline/enums/constants';
import { getFallbackPastYears } from 'timeline/utils/getFallbackPastYears';
import { getTimelinePageHeader } from 'timeline/utils/getTimelinePageHeader';
import { getTimelineYearsSortedByYearDesc } from 'timeline/utils/getTimelineYearsSortedByYearDesc';

export const useTimeline = (timelineBreadcrumbs) => {
  const { asPath, pathname, query } = useRouter();
  const timelineYear = query?.timelineYear?.[0];
  const isTimelinePath = pathname === TIMELINE_PATHNAME;
  const isPresent = isTimelinePath && asPath.split('/').length === 2;
  const { t } = useTranslation();

  if (!isTimelinePath) {
    return {};
  }

  const timelineYears = timelineBreadcrumbs
    ? getTimelineYearsSortedByYearDesc(timelineBreadcrumbs)
    : getFallbackPastYears();
  const { title, description } = getTimelinePageHeader({
    timePeriod: timelineYear,
    breadcrumbYears: timelineBreadcrumbs,
    t,
  });
  // future and present are not using constructor collection, and is just a 'release_date' filter
  const isFutureOrPresent = timelineYear === FUTURE || isPresent;
  const timelineIdType = isFutureOrPresent ? 'group_id' : 'collection_id';
  const timelineId = isFutureOrPresent ? 'sneakers' : `timeline-${timelineYear}`;

  return {
    timelineId,
    timelineIdType,
    timelineDescription: description,
    timelineTitle: title,
    timelineYears,
  };
};
